'use strict'
var polls = angular.module('pollsModule',[
	'ui.router',
	'servicesModule',
	'ngResource',
	"ngTable",
	'ngBootstrap'
]);
require('./allpolls/js/directive/allpollsDirective.js')(polls);
require('./allpolls/js/allpollsController.js')(polls);
require('./edit-newpoll/js/directive/pollDirective.js')(polls);
require('./edit-newpoll/js/pollController.js')(polls);



//////////////////
// WEBPACK FOOTER
// ./public/development/assets/ext-modules/pollsModule/pollsModule.js
// module id = 544
// module chunks = 0